/* eslint-disable camelcase */
import React from "react";
import cn from "classnames";

import { Text, SearchFilter } from "@themuse/design-system";

import { FacetProps, getFacetProps } from "utils/searchFacets";
import { useSearchFacetsState } from "hooks/SearchFacetsContext";
import {
    companyIndustryItems,
    companySizeItems,
    diversityInclusionItems,
    flattenPerksAndBenefits,
} from "utils/searchFacetItems";

import styles from "../SearchFacets.module.scss";

const CompanyFacets = (props: FacetProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { companyFacets } = useSearchFacetsState();
    const { perks_and_benefits } = companyFacets;

    return (
        <div className={styles.companyFilterSection}>
            <header className={styles.header}>
                <Text
                    htmlTag="h2"
                    textStyle="heading-3"
                    className={cn(styles.headerText, styles.subHeaderText)}
                >
                    Company Filters
                </Text>
            </header>
            <div className={styles.facetList}>
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "industry",
                    searchFilterItems: companyIndustryItems,
                    labelText: "Company Industry"
                })}
                />
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "companySize",
                    searchFilterItems: companySizeItems,
                    labelText: "Company Size"
                })}
                />
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "perks",
                    searchFilterItems: flattenPerksAndBenefits(perks_and_benefits),
                    labelText: "Perks and Benefits"
                })}
                />
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "companyLeadership",
                    searchFilterItems: diversityInclusionItems,
                    labelText: "Diversity & Inclusion"
                })}
                />
            </div>
        </div>
    );
};

export default CompanyFacets;
